/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
import { useAuthContext } from '@asgardeo/auth-react';
import AccessControlConstants from 'contexts/AccessControlConstants';
import { Perspectives } from 'types/perspectives';

export const useGetUserPerspectives = () => {
  const { getBasicUserInfo } = useAuthContext();

  const getUserPerspectives = async (): Promise<Perspectives[]> => {
    // For all users, DEV perspective is available
    const availablePerspectives: Perspectives[] = [Perspectives.DEV];
    const userInfo = await getBasicUserInfo();
    if (
      userInfo?.allowedScopes?.includes(
        AccessControlConstants.PLATFORM_ENGINEER_VIEW
      )
    ) {
      availablePerspectives.push(Perspectives.PE);
    }
    return availablePerspectives;
  };
  return { getUserPerspectives };
};
